import React, { useEffect, useRef, useState } from "react";
import { unstable_batchedUpdates } from "react-dom";
import { RecommendRow1 } from "../components/DataRow";
import Navbar from "../components/Navbar";
import { useScrollRestoration } from "../hooks/useScrollRestoration";

const STORAGE_KEY = "homeKeywordSearchState";

const KeywordSearch = () => {
  const [list, setList] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [flag, setFlag] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const restoringFromCache = useRef(false);

  // 使用 ref 保存当前状态，用于保存时获取最新值
  const stateRef = useRef({ list, keyword, page, flag });

  // 更新 ref
  useEffect(() => {
    stateRef.current = { list, keyword, page, flag };
  }, [list, keyword, page, flag]);

  // 使用滚动恢复 Hook
  useScrollRestoration({
    stateRef,
    setStates: (parsed) => {
      restoringFromCache.current = true;
      unstable_batchedUpdates(() => {
        if (parsed.list) setList(parsed.list);
        if (parsed.keyword) setKeyword(parsed.keyword);
        if (parsed.page) setPage(parsed.page);
        if (parsed.flag) setFlag(parsed.flag);
      });
      setIsInitialLoad(false);
      setTimeout(() => {
        restoringFromCache.current = false;
      }, 600);
    },
    storageKey: STORAGE_KEY,
  });

  const search = () => {
    // 关键修复：如果正在从缓存恢复，绝对不要执行搜索请求
    if (restoringFromCache.current) return;

    // 清除旧状态
    sessionStorage.removeItem(STORAGE_KEY);

    const url = [
      "/api/bulletin",
      "?option=notification-wx-default",
      "&category=国企,公务员,事业单位,教师,其他",
      "&address_level2=",
      `&keyword=${keyword}`,
      "&page=1",
    ];
    fetch(url.join(""))
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setList(data);
          setPage(page + 1);
        } else {
          console.info("服务器错误");
        }
      });
  };

  const handleChange = (event) => {
    setKeyword(event.target.value);
  };

  const _οnkeypress = (event) => {
    const keyCode = event.which || event.keyCode;
    if (keyCode === 13 && event.target.value !== "") {
      // 关键修复：执行新搜索时清除缓存
      sessionStorage.removeItem(STORAGE_KEY);
      search();
    }
  };

  useEffect(() => {
    document.title = "推荐信息查询";
  }, []);

  const load = () => {
    // 关键修复：如果正在从缓存恢复期间，绝对不要执行加载更多请求
    if (restoringFromCache.current) return;

    const url = [
      "/api/bulletin",
      "?option=notification-wx-default",
      "&category=国企,公务员,事业单位,教师,其他",
      "&address_level2=",
      `&keyword=${keyword}`,
      `&page=${page}`,
    ];
    fetch(url.join(""))
      .then((response) => response.json())
      .then((data) => {
        if (data.length) {
          setList(list.concat(data));
          setFlag(true);
          setPage(page + 1);
        } else {
          setFlag(true);
          alert("已经到底了");
          document.getElementById("load").innerHTML = "已经到底了";
          document.getElementById("load").disabled = true;
        }
      });
    setFlag(false);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row pb-2 pt-1 bg-transparent">
          <div className="col">
            <input
              type="text"
              id="search"
              className="w-100 border-0 text-center rounded-pill"
              placeholder="按照标题或城市名称查询"
              onChange={handleChange}
              onKeyPress={_οnkeypress}
              autoFocus
              style={{ outline: 0, height: 35 }}
            />
          </div>
        </div>
        <div className="card border-0 user-radius shadow">
          <div className="card-body">
            {list && list.map((item) => <RecommendRow1 key={item.id} {...item} />)}
            {flag === true ? (
              <button id="load" className="btn btn-block mx-auto" onClick={load}>
                点击加载更多
              </button>
            ) : (
              <div className="d-flex justify-content-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Navbar category="首页" />
    </>
  );
};

export default KeywordSearch;
